import { render, staticRenderFns } from "./FlagFormModal.vue?vue&type=template&id=8f5c0714&scoped=true&"
import script from "./FlagFormModal.vue?vue&type=script&lang=js&"
export * from "./FlagFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c0714",
  null
  
)

export default component.exports